import { ViewInterceptorEventsNamesEnum } from '../../enum/view-interceptor-directive/view-interceptor-events-names.enum';

export class ViewInterceptorEvent {

    public hidden: boolean;
    public visible: boolean;
    public element: HTMLElement;
    public eventName: string;

    constructor(
        private name: ViewInterceptorEventsNamesEnum,
        private visibility: boolean,
        private target: HTMLElement,
    ) {
        this.visible = visibility;
        this.hidden = !visibility;
        this.element = target;
        this.eventName = name;
    }

}
